import { HttpClient, HttpStatusCode } from '@/data/protocols/http'
import { AccessDeniedError, ResultWithoutRecordsError, UnexpectedError } from '@/domain/errors'
import { OpenLeaseReceipt, OpenLeaseReceiptParams } from '@/domain/usecases'
import { DocumentOpener } from '@/data/protocols/document-opener'

export class RemoteOpenLeaseReceipt implements OpenLeaseReceipt {
  constructor (
    private readonly url: string,
    private readonly httpGetClient: HttpClient<string>,
    private readonly documentOpener: DocumentOpener
  ) {}

  async open (params: OpenLeaseReceiptParams): Promise<void> {
    return await this.documentOpener.open(async () => {
      const { body, statusCode } = await this.httpGetClient.request({
        url: `${this.url}/api/portal/gerar-recibo-locacao`,
        method: 'get',
        params
      })

      switch (statusCode) {
        case HttpStatusCode.ok:
          if (!body) {
            throw new ResultWithoutRecordsError()
          }

          return `/${OpenLeaseReceipt.RN.FOLDER_DEFAULT_LEASE_RECEIPT}/${body}`
        case HttpStatusCode.unauthorized: throw new AccessDeniedError()
        default: throw new UnexpectedError()
      }
    })
  }
}
